export const WordleWords = [
    "Zebra",
    "Sling",
    "Crate",
    "Brick",
    "press",
    "truth",
    "sweet",
    "salty",
    "alert",
    "check",
    "roast",
    "toast",
    "shred",
    "cheek",
    "shock",
    "czech",
    "woman",
    "wreck",
    "court",
    "coast",
    "flake",
    "think",
    "smoke",
    "unrig",
    "slant",
    "ultra",
    "vague",
    "pouch",
    "radix",
    "yeast",
    "zoned",
    "cause",
    "quick",
    "bloat",
    "level",
    "civil",
    "civic",
    "madam",
    "house",
    "delay",
];
